import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from '@altermaind/core/i18n';
import { environment } from '../configuration/env';
import { linksDoc } from '../constants/linksDoc';

type GoToPublicsDocsProps = {
  goTo?: keyof typeof linksDoc;
};

export const usePublicDocs = () => {
  const currentLanguage = useSelector(selectors.selectCurrentLanguage);

  const goToPublicsDocs = useCallback(
    ({ goTo }: GoToPublicsDocsProps | undefined = {}) => {
      const documentationUrl = `${environment.VITE_APP_PUBLIC_DOCS}${currentLanguage === 'it' ? '' : `/${currentLanguage}`}${goTo ? `/${linksDoc[goTo]}` : ''}`;
      window.open(documentationUrl, '_blank');
    },
    [currentLanguage],
  );

  return { goToPublicsDocs };
};
